
import React, { useState } from 'react';
import { FiPlus, FiMinus } from 'react-icons/fi'; // Iconos de react-icons
import '../../css/TerminosDelSorteo.css'
import {CONSTANTES} from "../../config/constantaes";

const TerminosDelSorteo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  
 return (
    <div className='content-modal'>
      <div onClick={toggleAccordion} className='content-modal-titulo'>
        <strong className='titulo-term'>Términos del sorteo</strong>
        {isOpen ? <FiMinus color="#f44336" /> : <FiPlus color="#f44336" />}
      </div>

      <div className='context-modal'>
        {isOpen && (
            <p>
                <p>
                  Los TYC de la campaña La Suerte Te llama: 
                  Términos y condiciones de “La Suerte te Llama”. Vigencia: Del 20/04/2026 al 22/07/2026. Requisitos: (I) Para participar del sorteo, el usuario deberá registrarse por primera vez en cualquiera de nuestros canales habilitados: <a href="https://prestamos.alfinbanco.pe/" target="_blank" rel="noopener noreferrer">www.prestamos.alfinbanco.pe</a>, agencias mediante cupón físico o vía WhatsApp) y aceptar el Consentimiento para el Tratamiento de Datos Personales con Finalidades Comerciales. (II) El consentimiento brindado deberá mantenerse vigente durante toda la campaña y hasta la entrega del premio, en caso resulte ganador. (III) Los participantes no deberán mantener créditos con cuotas vencidas, castigadas, refinanciadas, reprogramadas o en proceso judicial con Alfin Banco S.A. a la fecha de cada sorteo y entrega del premio. Mecanismo de participación: (1) Al registrarse correctamente en cualquiera de los canales habilitados, se obtiene una 1 opción de participación. (2) Al cumplir con el mecanismo de participación Nro. (1) y adicionalmente realizar la contratación de un préstamo en Alfin Banco, tanto en agencia como a través de canal telefónico, se obtiene 5 opciones de participación. Fechas de sorteo: 29/05/2026, 26/06/2026 y 24/07/2026. Premios: Se otorgarán cien (100) premios en total, consistentes en vales de consumo de S/300 en tiendas Carsa y motos eléctricas (modelo BM-X9 – marca Roadland), según corresponda en cada sorteo. Los vales de consumo están sujetos a los términos y condiciones del proveedor. Más información de los términos y condiciones del sorteo en <a href="https://alfinbanco.pe/comunicados" target="_blank" rel="noopener noreferrer">www.alfinbanco.pe/comunicados</a>. 
                </p>

            </p>
        )}
      </div>
    </div>
 );
};

export default TerminosDelSorteo;